import React from 'react';
import { UsersIcon, MoreHorizontalIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
interface GroupCardProps {
  id: string;
  name: string;
  description?: string;
  learnerCount: number;
  createdBy: string;
  createdOn: string;
  status: 'active' | 'archived';
}
export const GroupCard: React.FC<GroupCardProps> = ({
  id,
  name,
  description,
  learnerCount,
  createdBy,
  createdOn,
  status
}) => {
  const navigate = useNavigate();
  return <motion.div whileHover={{
    y: -2
  }} onClick={() => navigate(`/classes/${id}`)} className="group bg-white rounded-xl border border-custom p-5 hover:border-[#00B75F]/50 hover:shadow-md transition-all cursor-pointer relative overflow-hidden" data-id="element-1500">
      {/* Status Stripe */}
      <div className={`absolute top-0 left-0 w-1 h-full ${status === 'active' ? 'bg-purple-500' : 'bg-gray-300'}`} data-id="element-1501" />

      <div className="flex justify-between items-start mb-3 pl-2" data-id="element-1502">
        <div className="flex items-start gap-3 flex-1" data-id="element-1503">
          <div className="w-10 h-10 rounded-xl bg-[#00B75F]/10 flex items-center justify-center text-[#00B75F] flex-shrink-0" data-id="element-1504">
            <div size={20} data-id="element-1505" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-1506">
            <div className="flex items-center gap-2 mb-1" data-id="element-1507">
              <h3 className="text-lg font-bold text-text-primary group-hover:text-[#00B75F] transition-colors truncate" data-id="element-1508">
                {name}
              </h3>
              {status === 'archived' && <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-gray-100 text-gray-500 uppercase tracking-wide border border-gray-200 flex-shrink-0" data-id="element-1509">
                  Archived
                </span>}
            </div>
            {description && <p className="text-sm text-text-secondary line-clamp-2" data-id="element-1510">
                {description}
              </p>}
          </div>
        </div>

        <button onClick={e => {
        e.stopPropagation();
        // Menu logic would go here
      }} className="p-1.5 rounded-lg text-text-tertiary hover:bg-gray-100 hover:text-text-primary transition-colors flex-shrink-0" data-id="element-1511">
          <MoreHorizontalIcon size={18} data-id="element-1512" />
        </button>
      </div>

      <div className="flex items-center gap-2 pl-2 mt-4" data-id="element-1513">
        <div className="flex items-center gap-1.5 text-sm text-text-secondary" data-id="element-1514">
          <UsersIcon size={16} className="text-text-tertiary" data-id="element-1515" />
          <span className="font-medium text-text-primary" data-id="element-1516">{learnerCount}</span>
          <span className="text-xs" data-id="element-1517">learners</span>
        </div>
      </div>

      <div className="mt-4 pt-3 border-t border-gray-100 flex justify-between items-center pl-2" data-id="element-1518">
        <span className="text-xs text-text-tertiary" data-id="element-1519">
          Created by {createdBy}
        </span>
        <span className="text-xs text-text-tertiary" data-id="element-1520">{createdOn}</span>
      </div>
    </motion.div>;
};